import React from 'react';
import PropTypes from 'prop-types';

import RadioSwatch from '../RadioSwatch/RadioSwatch';
import RadioBtn from '../RadioBtn/RadioBtn';
import RadioDropdownItem from '../RadioDropdownItem/RadioDropdownItem';
import RadioSwatchDropdownItem from '../RadioSwatchDropdownItem/RadioSwatchDropdownItem';
import { checkIfVariantAvailable } from '../../Utils/VariantUtils';
import { StyledLi } from './RadioStyles';

var Radio = function Radio(props) {
  var radioVariant = checkIfVariantAvailable(props.value, props.name, props.selectedOptions, props.variants);
  var optionAvailable = radioVariant.availableForSale;
  var active = props.checked;
  var id = props.parent + '-' + props.productId + '-' + props.value.replace(/['"]+/g, ''); // quotes breaking labels
  var name = props.name + '--' + props.productId; // quotes breaking labels
  return React.createElement(
    StyledLi,
    {
      active: active,
      'option-available': optionAvailable,
      type: props.radioType,
      parent: props.parent
    },
    React.createElement('input', {
      id: id,
      type: 'radio',
      onChange: props.handleOptionChange,
      name: name,
      value: props.value,
      defaultChecked: props.checked,
      'aria-label': props.name
    }),
    props.radioType == 'SWATCH' && React.createElement(RadioSwatch, {
      value: props.value,
      active: active,
      optionAvailable: optionAvailable,
      htmlFor: id,
      parent: props.parent
    }),
    props.radioType == 'BUTTON' && React.createElement(RadioBtn, {
      value: props.value,
      active: active,
      optionAvailable: optionAvailable,
      htmlFor: id
    }),
    props.radioType == 'DROPDOWN' && React.createElement(RadioDropdownItem, {
      value: props.value,
      active: active,
      optionAvailable: optionAvailable,
      htmlFor: id,
      price: radioVariant.price
    }),
    props.radioType == 'SWATCH_DROPDOWN' && React.createElement(RadioSwatchDropdownItem, {
      value: props.value,
      active: active,
      optionAvailable: optionAvailable,
      htmlFor: id
    })
  );
};

Radio.propTypes = {
  handleOptionChange: PropTypes.func.isRequired,
  checked: PropTypes.bool,
  toggleDropdown: PropTypes.func,
  name: PropTypes.string.isRequired,
  productId: PropTypes.string.isRequired,
  radioType: PropTypes.oneOf(['SWATCH', 'BUTTON', 'DROPDOWN', 'SWATCH_DROPDOWN']),
  parent: PropTypes.string,
  selectedOptions: PropTypes.object.isRequired,
  useDropdown: PropTypes.bool,
  value: PropTypes.string.isRequired,
  variants: PropTypes.array.isRequired
};

export default React.memo(Radio);